import React from 'react'
import {
  Container,
  TextBody,
  ListContainer,
  Icon
} from '@pmi/pmi-iqos-ds-react'
import { htmlTranslation } from '@pmi/pmi-iqos-shared-react'

const SummaryPrice = ({
  subtotal,
  delivery,
  deliveryFlat,
  discount,
  discountFlat,
  translations,
  surchargeValue,
  surchargeTitle,
  promotions,
  coupons,
  handleCouponAction
}) => {
  return (
    <Container divider={Container.dividers.top}>
      <Container pb="6" pt="6">
        <ListContainer columns={2} xBetween="2">
          <Container fullWidth>
            <TextBody
              size={TextBody.sizes.m}
              style={TextBody.styles.grayedout}
              {...htmlTranslation(translations, 'tk_summarySubtotal')}
            />
          </Container>
          <Container fullWidth>
            <TextBody
              size={TextBody.sizes.m}
              alignment={TextBody.alignments.right}
              data-testing="Checkout_TextBody_Subtotal">
              {subtotal}
            </TextBody>
          </Container>
        </ListContainer>
      </Container>
      <Container pb="6">
        <ListContainer columns={2} xBetween="2">
          <Container fullWidth>
            <TextBody
              size={TextBody.sizes.m}
              style={TextBody.styles.grayedout}
              {...htmlTranslation(translations, 'tk_summaryDelivery')}
            />
          </Container>
          <Container fullWidth>
            {deliveryFlat === 0 ? (
              <TextBody
                size={TextBody.sizes.m}
                style={TextBody.styles.success}
                alignment={TextBody.alignments.right}
                data-testing="Checkout_TextBody_FreeShipping"
                {...htmlTranslation(translations, 'tk_freeShipping')}
              />
            ) : (
              <TextBody
                size={TextBody.sizes.m}
                style={TextBody.styles.success}
                alignment={TextBody.alignments.right}
                data-testing="Checkout_TextBody_Delivery">
                {delivery}
              </TextBody>
            )}
          </Container>
        </ListContainer>
      </Container>
      {surchargeValue && (
        <Container pb="6">
          <ListContainer columns={2} xBetween="2">
            <Container fullWidth>
              <TextBody
                size={TextBody.sizes.m}
                style={TextBody.styles.grayedout}
                data-testing="Checkout_TextBody_SurchargeTitle">
                {surchargeTitle}
              </TextBody>
            </Container>
            <Container fullWidth>
              <TextBody
                size={TextBody.sizes.m}
                alignment={TextBody.alignments.right}
                data-testing="Checkout_TextBody_SurchargeValue">
                {surchargeValue}
              </TextBody>
            </Container>
          </ListContainer>
        </Container>
      )}
      {discount ? (
        <Container pb="6">
          <ListContainer columns={2} xBetween="2">
            <Container fullWidth>
              <TextBody
                size={TextBody.sizes.m}
                style={TextBody.styles.grayedout}
                {...htmlTranslation(translations, 'tk_summaryDiscount')}
              />
            </Container>
            <Container fullWidth>
              {discountFlat === 0 ? (
                <TextBody
                  size={TextBody.sizes.m}
                  alignment={TextBody.alignments.right}
                  data-testing="Checkout_TextBody_Discount">
                  {discount}
                </TextBody>
              ) : (
                <TextBody
                  size={TextBody.sizes.m}
                  style={TextBody.styles.error}
                  alignment={TextBody.alignments.right}
                  data-testing="Checkout_TextBody_Discount">
                  - {discount}
                </TextBody>
              )}
            </Container>
          </ListContainer>
        </Container>
      ) : null}
      {promotions && promotions.length > 0 && (
        <Container pb="6">
          <ListContainer columns={2} xBetween="2">
            <Container fullWidth>
              <TextBody
                size={TextBody.sizes.m}
                style={TextBody.styles.grayedout}
                {...htmlTranslation(translations, 'tk_appliedPromotions')}
              />
            </Container>
            <Container fullWidth>
              {promotions
                .filter(promotion => promotion.confirmed !== false)
                .map((promotion, index) => {
                  return (
                    <TextBody
                      key={index}
                      size={TextBody.sizes.m}
                      style={TextBody.styles.success}
                      alignment={TextBody.alignments.right}
                      data-testing="Checkout_TextBody_PromotionName">
                      {promotion.name}
                    </TextBody>
                  )
                })}
            </Container>
          </ListContainer>
        </Container>
      )}
      {coupons && coupons.length > 0 && (
        <Container pb="6">
          <ListContainer columns={2} xBetween="2">
            <Container fullWidth>
              <TextBody
                size={TextBody.sizes.m}
                style={TextBody.styles.grayedout}
                {...htmlTranslation(translations, 'tk_appliedCoupon')}
              />
            </Container>
            <Container fullWidth>
              {coupons.map((coupon, index) => {
                return (
                  <Container
                    key={index}
                    display={Container.displays.flex}
                    justifyContent={Container.justifyContentValues.end}
                    alignItems={Container.alignItemsValues.center}>
                    <TextBody
                      size={TextBody.sizes.m}
                      style={TextBody.styles.success}
                      alignment={TextBody.alignments.right}
                      data-testing="Checkout_TextBody_Coupon">
                      {coupon.code}
                    </TextBody>
                    <Container
                      pl="4"
                      py="1"
                      onClickHandler={() =>
                        handleCouponAction('remove', coupon.code)
                      }
                      data-testing="Checkout_Overlay_RemoveCoupon">
                      <Icon size={Icon.sizes.xs} image={Icon.images.cancel} />
                    </Container>
                  </Container>
                )
              })}
            </Container>
          </ListContainer>
        </Container>
      )}
    </Container>
  )
}

export default SummaryPrice
